import { render, staticRenderFns } from "./CreateAllergen.vue?vue&type=template&id=c346cb54&scoped=true"
import script from "./CreateAllergen.vue?vue&type=script&lang=ts"
export * from "./CreateAllergen.vue?vue&type=script&lang=ts"
import style0 from "./CreateAllergen.vue?vue&type=style&index=0&id=c346cb54&prod&lang=scss&scoped=true"
import style1 from "./CreateAllergen.vue?vue&type=style&index=1&id=c346cb54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c346cb54",
  null
  
)

export default component.exports